import Vue from "vue";
import VueI18n from "vue-i18n";
import ru from "element-ui/lib/locale/lang/ru-RU";
import en from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

import { RU, EN } from "@/domain/locales.types";

Vue.use(VueI18n);

function setElementLocale(locale, messages) {
  if (locale == RU) {
    messages[locale] = { ...messages[locale], ...ru };
  } else if (locale == EN) {
    messages[locale] = { ...messages[locale], ...en };
  }
}

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
      setElementLocale(locale, messages);
    }
  });
  return messages;
}

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || RU,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || EN,
  messages: loadLocaleMessages()
});

locale.i18n((key, value) => i18n.t(key, value));

export default i18n;
